var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.container},[_c('div',{class:[( _obj = {}, _obj[_vm.$style.contentInfo] = _vm.info, _obj ), _vm.$style.content]},[(_vm.data.icon)?_c('BaseIcon',{class:_vm.$style.content__icon,attrs:{"name":_vm.data.icon}}):_vm._e(),_vm._v(" "),_c('p',{class:_vm.$style.content__paragraph},[_vm._v("\n        "+_vm._s(_vm.data.text)+"\n      ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }